enum EvidenceTabEnum {
    ITEM = 'ITEM',
    EVIDENCE = 'EVIDENCE'
}

export { EvidenceTabEnum }